// extracted by mini-css-extract-plugin
export default {"content":"CommonModal_content__HJ0PP","footer":"CommonModal_footer__vntYw"};